import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from '@mui/material';
import { EventData } from '../../types/event';
import { eventService } from '../../services/eventService';

interface DeleteEventDialogProps {
  event: EventData | null;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
  onSnackbar: (message: string, severity: 'success' | 'error') => void;
}

export const DeleteEventDialog: React.FC<DeleteEventDialogProps> = ({
  event,
  open,
  onClose,
  onDeleted,
  onSnackbar,
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!event) return;
    setIsDeleting(true);
    try {
      await eventService.deleteEvent(event.id);
      onSnackbar('イベントを削除しました', 'success');
      onDeleted();
      onClose();
    } catch {
      onSnackbar('イベントの削除に失敗しました', 'error');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>イベントを削除しますか？</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          「{event?.title}」を削除します。参加者情報も含め削除されます。この操作は元に戻せません。
        </Typography>
        {event?.unread_notification_count !== undefined && event.unread_notification_count > 0 && (
          <Typography variant="caption" color="warning.main" display="block" mt={1}>
            ※ このイベントには未読通知が {event.unread_notification_count}件 あります。
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isDeleting}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleDelete}
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          削除する
        </Button>
      </DialogActions>
    </Dialog>
  );
};
